import LoadingSpinner from '@carvana/loading-spinner';
import { ModalContent, ModalHeader, ModalCloseButton } from '@carvana/modal';
import { cvBreakpoint768 } from '@carvana/theme';
import styled from 'styled-components';

export const CloseButton = styled(ModalCloseButton)`
  transform: scale(1.25);
`;

export const NoCloseButton = styled(ModalCloseButton)`
  display: none;
`;

export const Header = styled(ModalHeader)`
  font-size: 16px;
  text-transform: none;
`;

export const Content = styled(ModalContent)`
  background-color: white;
  min-height: 100px;
  z-index: 1301;

  @media (min-width: ${cvBreakpoint768}px) {
    max-width: 910px;
  }

  &.loading {
    overflow-y: visible;
  }
`;

export const ContentWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 100px 30px 50px;
  position: relative;

  @media (min-width: ${cvBreakpoint768}px) {
    padding-top: 50px;
  }
`;

const transitionSpeed = '.25s';

export const ModalLoadingSpinner = styled(LoadingSpinner).attrs({
  isLarge: true
})`
  background-color: white;
  bottom: 0;
  opacity: 0;
  top: 0;
  transition: opacity ${transitionSpeed}, visibility ${transitionSpeed};
  visibility: hidden;

  &.show {
    opacity: 1;
    visibility: visible;
  }
`;

export const BoldText = styled.p`
  color: ${props => props.theme.carvana.blue.dark};
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 8px;
  margin-top: 24px;
  text-align: center;
`;

export const BodyText = styled.p`
  color: ${props => props.theme.carvana.gray.dark};
  max-width: 340px;
  text-align: center;
`;

export const ButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 40px;

  @media (min-width: ${cvBreakpoint768}px) {
    flex-direction: row;
    justify-content: center;
  }
`;
